(function () {
  function bindHero(root) {
    if (!root || root.getAttribute('data-pd26-review-bound') === 'true') return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pd26-review-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pd26-review-dots] [data-index]'));
    if (!slides.length) return;

    root.setAttribute('data-pd26-review-bound', 'true');

    var current = 0;

    function classFor(index, active) {
      var offset = (index - active + slides.length) % slides.length;
      if (offset === 0) return 'is-active';
      if (offset === slides.length - 1) return 'is-prev';
      if (offset === 1) return 'is-next';
      return 'is-idle';
    }

    function goTo(nextIndex) {
      current = ((nextIndex % slides.length) + slides.length) % slides.length;
      slides.forEach(function (slide, index) {
        slide.classList.remove('is-active', 'is-prev', 'is-next', 'is-idle');
        slide.classList.add(classFor(index, current));
      });
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === current);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.getAttribute('data-index')) || 0);
      });
    });

    slides.forEach(function (slide) {
      slide.addEventListener('click', function (event) {
        if (slide.classList.contains('is-active')) return;
        event.preventDefault();
        goTo(Number(slide.getAttribute('data-index')) || 0);
      });
    });

    var stage = root.querySelector('[data-pd26-review-slides]');
    var touchStartX = null;
    if (stage) {
      stage.addEventListener('touchstart', function (event) {
        touchStartX = event.changedTouches[0] ? event.changedTouches[0].clientX : null;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (touchStartX == null) return;
        var endX = event.changedTouches[0] ? event.changedTouches[0].clientX : touchStartX;
        var delta = endX - touchStartX;
        touchStartX = null;
        if (Math.abs(delta) < 40) return;
        goTo(current + (delta < 0 ? 1 : -1));
      }, { passive: true });
    }
  }

  function queryParam(url, name) {
    var match = String(url).match(new RegExp('[?&]' + name + '=([^&]+)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function pathToken(url, marker) {
    var index = url.toLowerCase().indexOf(marker);
    if (index < 0) return '';
    return url.slice(index + marker.length).split(/[?&#/]/)[0];
  }

  function toEmbed(url) {
    if (!url) return '';
    var lower = url.toLowerCase();

    if (lower.indexOf('instagram.com') !== -1) {
      var cleaned = url.split('?')[0].split('#')[0].replace(/\/+$/, '');
      if (/\/(p|reel|tv)\/[^/]+$/i.test(cleaned)) return cleaned + '/embed';
      return '';
    }

    var id = pathToken(url, 'youtu.be/') || pathToken(url, '/shorts/') || queryParam(url, 'v') || pathToken(url, 'embed/');
    if (!id) return '';

    var embed = 'https://www.youtube.com/embed/' + id + '?rel=0&autoplay=1';
    var start = queryParam(url, 't').replace(/s$/i, '');
    if (start && /^\d+$/.test(start)) embed += '&start=' + start;
    return embed;
  }

  function bindVideos(root) {
    if (!root || root.getAttribute('data-pd26-review-bound') === 'true') return;

    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-pd26-review-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pd26-review-card]'));
    var scroller = root.querySelector('[data-pd26-review-scroller]');
    var progress = root.querySelector('[data-pd26-review-progress]');
    var dialog = root.querySelector('[data-pd26-review-dialog]');
    var dialogIframe = root.querySelector('[data-pd26-review-dialog-iframe]');
    var dialogClose = root.querySelector('[data-pd26-review-dialog-close]');
    var dialogTitle = root.querySelector('.pd26-review-videos__dialog-title');
    if (!filters.length) return;

    root.setAttribute('data-pd26-review-bound', 'true');

    var drag = { x: 0, y: 0, moved: false, active: false };

    function stopDialogVideo() {
      if (!dialogIframe) return;
      dialogIframe.setAttribute('src', '');
      dialogIframe.setAttribute('title', '');
    }

    function closeDialog() {
      if (dialog && dialog.open) dialog.close();
    }

    function openDialog(embed, title) {
      if (!dialog || !dialogIframe || typeof dialog.showModal !== 'function') return;
      dialogIframe.setAttribute('src', embed);
      dialogIframe.setAttribute('title', title || 'Video');
      if (dialogTitle) dialogTitle.textContent = title || 'Video';
      dialog.showModal();
    }

    function updateProgress() {
      if (!scroller || !progress) return;
      var max = scroller.scrollWidth - scroller.clientWidth;
      var ratio = max <= 0 ? 1 : Math.min(1, scroller.scrollLeft / max);
      progress.style.width = Math.max(32, Math.round((ratio * 70) + 30)) + '%';
    }

    function applyFilter(category) {
      filters.forEach(function (button) {
        var active = button.getAttribute('data-pd26-review-filter') === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      cards.forEach(function (card) {
        card.classList.toggle('is-hidden', card.getAttribute('data-category') !== category);
      });
      if (scroller) scroller.scrollTo({ left: 0, behavior: 'smooth' });
      updateProgress();
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        applyFilter(button.getAttribute('data-pd26-review-filter'));
      });
    });

    if (scroller) {
      scroller.addEventListener('scroll', updateProgress, { passive: true });
      scroller.addEventListener('pointerdown', function (event) {
        drag.x = event.clientX;
        drag.y = event.clientY;
        drag.moved = false;
        drag.active = true;
      });
      scroller.addEventListener('pointermove', function (event) {
        if (!drag.active) return;
        if (Math.abs(event.clientX - drag.x) > 8 || Math.abs(event.clientY - drag.y) > 8) {
          drag.moved = true;
        }
      });
      scroller.addEventListener('pointerup', function () {
        drag.active = false;
      });
      scroller.addEventListener('pointercancel', function () {
        drag.active = false;
      });
      updateProgress();
    }

    root.addEventListener('click', function (event) {
      var card = event.target.closest('[data-pd26-review-card]');
      if (!card || !root.contains(card)) return;
      if (drag.moved) {
        event.preventDefault();
        return;
      }
      var embed = toEmbed(card.getAttribute('href') || '');
      if (!embed) return;
      event.preventDefault();
      var titleNode = card.querySelector('.pd26-review-video-card__title');
      openDialog(embed, titleNode ? titleNode.textContent.trim() : 'Video');
    });

    if (dialogClose) dialogClose.addEventListener('click', closeDialog);
    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', stopDialogVideo);
    }
  }

  function bindStories(root) {
    if (!root || root.getAttribute('data-pd26-review-bound') === 'true') return;

    var scroller = root.querySelector('[data-pd26-review-stories-scroller]');
    if (!scroller) return;

    root.setAttribute('data-pd26-review-bound', 'true');

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var pendingLink = null;
    var blockClick = false;

    function canScroll() {
      return scroller.scrollWidth - scroller.clientWidth > 1;
    }

    function syncScrollable() {
      var scrollable = canScroll();
      scroller.classList.toggle('is-scrollable', scrollable);
      if (!scrollable) scroller.scrollLeft = 0;
    }

    function openCard(link) {
      if (!link || !link.href) return;
      if (link.target === '_blank') {
        window.open(link.href, '_blank', 'noopener,noreferrer');
        return;
      }
      window.location.assign(link.href);
    }

    scroller.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    scroller.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !canScroll()) return;

      event.preventDefault();
      blockClick = true;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = scroller.scrollLeft;
      pendingLink = event.target.closest('.pd26-review-stories__card');
      scroller.classList.add('is-dragging');
      scroller.setPointerCapture(event.pointerId);
    });

    scroller.addEventListener('pointermove', function (event) {
      if (!dragging) return;

      var delta = event.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      scroller.scrollLeft = startScroll - delta;
    });

    function endDrag(event) {
      if (!dragging) return;

      var link = pendingLink;
      var shouldOpen = !moved;
      dragging = false;
      pendingLink = null;
      scroller.classList.remove('is-dragging');
      if (event && event.pointerId != null && scroller.hasPointerCapture(event.pointerId)) {
        scroller.releasePointerCapture(event.pointerId);
      }
      if (shouldOpen) openCard(link);
      window.setTimeout(function () {
        blockClick = false;
        moved = false;
      }, 50);
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', function (event) {
      moved = true;
      endDrag(event);
    });

    scroller.addEventListener('click', function (event) {
      if (!blockClick && !moved) return;
      event.preventDefault();
      event.stopPropagation();
      blockClick = false;
      moved = false;
    }, true);

    syncScrollable();
    window.addEventListener('resize', syncScrollable);
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(syncScrollable);
      observer.observe(scroller);
    }
  }

  function bindSocial(root) {
    if (!root || root.getAttribute('data-pd26-review-bound') === 'true') return;

    var grid = root.querySelector('[data-pd26-review-social-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pd26-review-social-card]'));
    if (!grid || !cards.length) return;

    root.setAttribute('data-pd26-review-bound', 'true');

    var desktop = window.matchMedia('(min-width: 768px)');

    function clear() {
      cards.forEach(function (card) {
        card.classList.remove('is-active');
      });
    }

    function activate(card) {
      if (!desktop.matches) return;
      cards.forEach(function (item) {
        item.classList.toggle('is-active', item === card);
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        activate(card);
      });
      card.addEventListener('focusin', function () {
        activate(card);
      });
    });

    grid.addEventListener('mouseleave', clear);
    grid.addEventListener('focusout', function (event) {
      if (!grid.contains(event.relatedTarget)) clear();
    });

    function onDesktopChange() {
      if (!desktop.matches) clear();
    }

    if (desktop.addEventListener) desktop.addEventListener('change', onDesktopChange);
    else if (desktop.addListener) desktop.addListener(onDesktopChange);
  }

  function bindQuotes(root) {
    if (!root || root.getAttribute('data-pd26-review-bound') === 'true') return;

    var more = root.querySelector('[data-pd26-review-more]');
    if (!more) return;

    root.setAttribute('data-pd26-review-bound', 'true');

    more.addEventListener('click', function () {
      root.classList.add('is-expanded');
    });
  }

  function init(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-pd26-review-hero]').forEach(bindHero);
    context.querySelectorAll('[data-pd26-review-stories]').forEach(bindStories);
    context.querySelectorAll('[data-pd26-review-videos]').forEach(bindVideos);
    context.querySelectorAll('[data-pd26-review-social]').forEach(bindSocial);
    context.querySelectorAll('[data-pd26-review-quotes]').forEach(bindQuotes);

    if (context.hasAttribute && context.hasAttribute('data-pd26-review-hero')) bindHero(context);
    if (context.hasAttribute && context.hasAttribute('data-pd26-review-stories')) bindStories(context);
    if (context.hasAttribute && context.hasAttribute('data-pd26-review-videos')) bindVideos(context);
    if (context.hasAttribute && context.hasAttribute('data-pd26-review-social')) bindSocial(context);
    if (context.hasAttribute && context.hasAttribute('data-pd26-review-quotes')) bindQuotes(context);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
